module.exports = {
  'en': {
    'HRMS1AX1': {
      '10': 'Emp. Code',
      '20': 'Employee Name',
      '30': 'Position',
      '40': 'Department',
      '50': 'Date',
      '60': 'Day',
      '70': 'Shift',
      '80': '',
      '90': 'In',
      '100': 'Out',
      '110': 'Real time',
      '120': 'Check in location',
      '130': 'Check Coordinates',
      '140': 'Check In',
      '150': 'Check Out'
    }
  },
  'th': {
    'HRMS1AX1': {
      '10': 'รหัสพนักงาน',
      '20': 'ชื่อ-นามสกุล',
      '30': 'ตำแหน่ง',
      '40': 'หน่วยงาน',
      '50': 'วันที่',
      '60': 'วัน',
      '70': 'กะ',
      '80': 'เวลาที่กำหนด',
      '90': 'เข้า',
      '100': 'ออก',
      '110': 'เวลาที่ทำงานจริง',
      '120': 'สถานที่ Check In',
      '130': 'พิกัดที่ Check In',
      '140': 'Check In',
      '150': 'Check Out'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrms1ax.js